import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import { IoPrintOutline } from "react-icons/io5";
import { useReactToPrint } from "react-to-print";

const FormShowContract = () => {
   const [status_guarantee, setStatusGuarantee] = useState("");
   const [status_contract, setStatusContract] = useState("");
   const [contract_no, setContractNo] = useState("");
   const [client_name, setClientName] = useState("");
   const [address, setAddress] = useState("");
   const [email, setEmail] = useState("");
   const [phone, setPhone] = useState("");
   const [start_guarantee, setStartGuarantee] = useState(""); 
   const [end_guarantee, setEndGuarantee] = useState("");
   const [start_contract, setStartContract] = useState(""); 
   const [end_contract, setEndContract] = useState("");
   const [contract_value, setContractValue] = useState(""); 
   const [created_by, setCreatedBy] = useState("");
   const [contract_item, setContractItem] = useState([]);

   const [companyname, setCompanyName] = useState("");
   const [companyaddress, setCompanyAddress] = useState("");
   const [companyemail, setCompanyEmail] = useState("");
   const [companyphone, setCompanyPhone] = useState("");
   const [companyfax, setCompanyFax] = useState("");
   const [url, setUrl] = useState("");
   const [msg, setMsg] = useState("");
   const { id, idClient, idSale } = useParams();
   // Access the environment variables
   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
   const API_KEY = process.env.REACT_APP_API_KEY;

   const componentRef = useRef();
   
   const handlePrint = useReactToPrint({
      documentTitle: 'Title',
      contentRef: componentRef,
   })

   useEffect(() => {
      const getContractById = async () => {
         try {
            //get data sales contract
            const response = await axios.get(
               `${API_BASE_URL}/contracts/${id}`, {
                  headers: {
                     'X-API-Key': API_KEY
                  },
               }
            );     
            //console.log(response.data);       
            // get data cutomer
            const idClient = response.data.clientId;
            const responseclient = await axios.get(
               `${API_BASE_URL}/customers/${idClient}`, {
                  headers: {
                     'X-API-Key': API_KEY
                  },
               }
            );

            // get data product item
            const idContract = response.data.id;
            const contractitem = await axios.get(
               `${API_BASE_URL}/contractitem/${idContract}`, {
                  headers: {
                     'X-API-Key': API_KEY
                  },
               }
            );
            setContractItem(contractitem.data);

            setClientName(responseclient.data.name);
            setAddress(responseclient.data.address);
            setPhone(responseclient.data.phone);
            setEmail(responseclient.data.email);
           
            setContractNo(response.data.contract_no);
            setContractValue(response.data.contract_value);
            setStartGuarantee(response.data.start_guarantee);
            setEndGuarantee(response.data.end_guarantee);
            setStartContract(response.data.start_contract);
            setEndContract(response.data.end_contract);
            setCreatedBy(response.data.user.name);
            setCreatedBy(response.data.user.name);

            const start = new Date();
            const end = new Date(response.data.end_guarantee);
            const timeDifference = end.getTime() - start.getTime(); // Difference in milliseconds
            const millisecondsPerDay = 1000 * 60 * 60 * 24; // Milliseconds in a day
            const daysDifference = Math.floor(timeDifference / millisecondsPerDay); // Use Math.floor for whole days
            if(daysDifference < 0){
               setStatusGuarantee("EXPIRED");
            }else{
               setStatusGuarantee("GUARANTEE");
            }

            const startcontract = new Date();
            const endcontract = new Date(response.data.end_contract);
            const timeDifference2 = endcontract.getTime() - startcontract.getTime(); // Difference in milliseconds
            const millisecondsPerDay2 = 1000 * 60 * 60 * 24; // Milliseconds in a day
            const daysDifference2 = Math.floor(timeDifference2 / millisecondsPerDay2); // Use Math.floor for whole days
            setStatusContract(daysDifference2+" Days");
           
           
         } catch (error) {
            console.error(error);
            if (error.response) {
               setMsg(error.response.data.msg);
            }
         }
      };

      const getCompany = async () => {
         try {
            //get data sales contract
            const response = await axios.get(`${API_BASE_URL}/companies`, {
               headers: {
                  'X-API-Key': API_KEY
               },
            });  
            setCompanyName(response.data[0].name);
            setCompanyAddress(response.data[0].address);  
            setCompanyEmail(response.data[0].email);  
            setCompanyPhone(response.data[0].phone);  
            setCompanyFax(response.data[0].fax);
            setUrl(response.data[0].url);
         } catch (error) {
               console.error(error);
               if (error.response) {
                  setMsg(error.response.data.msg);
               }
         }
      };
      getContractById();
      getCompany();
   }, [id, idClient, idSale]);
   return (
      <div className="container">
         <div className="columns">           
           <div className="column is-full">
            <div className="buttons is-right">
               <button className="button is-link mr-2" onClick={handlePrint}><IoPrintOutline /> Print</button>
               <Link to="/contracts">
                  <button className="button is-black mr-4">
                     Back
                  </button>
               </Link>
            </div>
           </div>
         </div>
         <div className="pl-4 pr-4" ref={componentRef}>
            <div className="columns mt-2">
               <div className="column has-text-left is-2">
                  <figure className="image is-5by3">
                     <img src={url} alt="Preview Image" />
                  </figure>
               </div>
               <div className="column has-text-centered is-8">
                  <h1 className="title has-text-weight-bold is-size-5">{companyname}</h1>
                  <h3 className="title is-size-7">{companyaddress}<br/>Phone: {companyphone}, Fax: {companyfax}, Email: {companyemail}</h3>  
               </div>
            </div>
            <hr/>
            <h1 className="has-text-centered has-text-weight-bold is-size-5">DETAIL OF CONTRACTS</h1>
             <p className="has-text-centered is-size-6">CONTRACT_NO: {contract_no}</p>
            <h3 className="title is-size-6">DATA CONTRACT</h3>  
            
            <div className="field is-horizontal">
               <div className="field-label is-normal has-text-right">
                  <label className="label">Customer_Name:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input" type="text" value={client_name} onChange={(e) => setClientName(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div>
            <div className="field is-horizontal">
               <div className="field-label is-normal">
                  <label className="label">Address:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input" type="text" value={address} onChange={(e) => setAddress(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div> 
            <div className="field is-horizontal">
               <div className="field-label is-normal">
                  <label className="label">Email:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input" type="text" value={email} onChange={(e) => setEmail(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div> 
            <div className="field is-horizontal">
               <div className="field-label is-normal">
                  <label className="label">Phone:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input" type="text" value={phone || ""} onChange={(e) => setPhone(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div> 
            <div className="field is-horizontal">
               <div className="field-label is-normal">
                  <label className="label">Start_Contract:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">                           
                        <input disabled className="input" type="text" value={new Date(start_contract).toLocaleDateString('id', {
                           year: 'numeric',
                           month: 'long',
                           day: 'numeric',
                        })} onChange={(e) => setStartContract(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div>   
            <div className="field is-horizontal">
               <div className="field-label is-normal">
                  <label className="label">End_Contract:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input" type="text" value={new Date(end_contract).toLocaleDateString('id', {
                           year: 'numeric',
                           month: 'long',
                           day: 'numeric',
                        })} onChange={(e) => setEndContract(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div>  
            <div className="field is-horizontal mb-2">
               <div className="field-label is-normal">
                  <label className="label">Contract_Remaining:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input has-text-weight-bold" type="text" value={status_contract} onChange={(e) => setStatusContract(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div>
            <div className="field is-horizontal">
               <div className="field-label is-normal">
                  <label className="label">Start_Guarantee:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                           
                        <input disabled className="input" type="text" value={new Date(start_guarantee).toLocaleDateString('id', {
                           year: 'numeric',
                           month: 'long',
                           day: 'numeric',
                        })} onChange={(e) => setStartGuarantee(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div>   
            <div className="field is-horizontal">
               <div className="field-label is-normal">
                  <label className="label">End_Guarantee:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input" type="text" value={new Date(end_guarantee).toLocaleDateString('id', {
                           year: 'numeric',
                           month: 'long',
                           day: 'numeric',
                        })} onChange={(e) => setEndGuarantee(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div>  
            <div className="field is-horizontal mb-2">
               <div className="field-label is-normal">
                  <label className="label">Status_Guarantee:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input has-text-weight-bold" type="text" value={status_guarantee} onChange={(e) => setStatusGuarantee(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div>
            <div className="field is-horizontal">
               <div className="field-label is-normal has-text-right">
                  <label className="label">Contract_Value:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <NumericFormat
                           disabled
                           id="contract_value"
                           className="input"
                           value={contract_value}
                           thousandSeparator={true}
                           decimalScale={2}
                           fixedDecimalScale={true}
                           allowNegative={false}
                           valueIsNumericString={true} 
                        />
                     </div>
                  </div>
               </div>
            </div>  
            
            <h3 className="title is-size-6">DATA PRODUCT</h3>
            <table className="table is-striped is-fullwidth is-size-6">
               <thead>
                  <tr>
                     <th style={{width: "1%"}}>No</th>
                     <th className="has-text-centered">Image</th>
                     <th className="has-text-centered">Product_Name</th>
                     <th className="has-text-centered">Qty</th>
                  </tr>
               </thead>
               <tbody>
                     {contract_item.map((item, index) => (
                        <tr key={item.uuid}>
                           <td>{index + 1}</td>
                           <td>
                              <figure className="image is-48x48">
                                 <img src={item.product.url} alt="Image" />
                              </figure>
                           </td>
                           <td>{item.product.name}</td>                                                
                           <td className="has-text-centered">
                              <NumericFormat
                                 value={item.qty}
                                 displayType="text" // Renders as a <span> instead of an input
                                 thousandSeparator={true}
                                 decimalScale={0}
                                 fixedDecimalScale={true} />
                           </td>
                        </tr>
                     ))}
               </tbody>
            </table> 
            <div className="columns">
            <div className="column is-half">
               Jakarta, {new Date(start_contract).toLocaleDateString('id', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        })}
            </div>
            <div className="column has-text-right is-4">
               <span className="mr-3">
               Disetujui
               </span>
            </div>
            </div> 
            <div className="columns">
            <div className="column is-half">
               
            </div>
            <div className="column has-text-right is-4">
               <span className="mr-3">
               
               </span>
            </div>
            </div> 
            <div className="columns">
            <div className="column is-half">
               {created_by}
            </div>
            <div className="column has-text-right is-4">
               <span className="mr-3">
                  Customer
               </span>
            </div>
            </div>
         </div>                         
      </div>
   );
};

export default FormShowContract;
